import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Bullet, Skeleton, TruncatableText } from "@particles/index"

import { Badge, Icon } from "@atoms"

import useObjectCard from "@molecules/ObjectCard/ObjectCard.context"

import styles from "./ObjectCardHeader.module.scss"
import { ObjectCardHeaderProps } from "./ObjectCardHeader.types"

export default function ObjectCardHeader(props: ObjectCardHeaderProps) {
    const { id, idPlaceholder, subId, subIdLabel, showSeenIcon = false, statusBadge, className } = props

    const { isLoading } = useObjectCard()

    if (isLoading) {
        return (
            <div className={clsx(styles.base, className)}>
                <div className={styles.idSkeleton}>
                    <Skeleton height={10} width={80} borderRadius={0} />
                </div>
                {statusBadge && (
                    <div className={styles.statusSlot}>
                        <Badge size="md" isLoading={true} loadingWidth={80} />
                    </div>
                )}
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.base, className)}>
                {showSeenIcon && (
                    <Icon
                        className={styles.seenIcon}
                        icon={faIcon({ name: "eye", style: "regular" })}
                        size={14}
                        container="fixedHeight"
                    />
                )}
                <div className={styles.idGroup}>
                    {id ? (
                        <TruncatableText className={styles.id} text={id} tooltipOnTruncate={true} />
                    ) : (
                        <span className={clsx(styles.id, styles.idPlaceholder)}>{idPlaceholder}</span>
                    )}
                    {subId && (
                        <>
                            <Bullet className={clsx(styles.id, styles.separator)} />
                            <TruncatableText
                                className={clsx(styles.id, styles.subId)}
                                text={subId}
                                tooltipOverride={subIdLabel ? `${subIdLabel}\n${subId}` : undefined}
                                alwaysShowTooltip={true}
                                tooltipPlacement="bottom"
                            />
                        </>
                    )}
                </div>
                {statusBadge && <div className={styles.statusSlot}>{statusBadge}</div>}
            </div>
        )
    }
}
